import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4a7121c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination-container mt15" }

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    currentPage:Number,
    pageSize:Number,
    total:Number,
    background: Boolean
},
  emits: ['update:currentPage', 'update:pageSize','pagination'],
  setup(__props, { emit: __emit }) {

const props = __props
const currentPage = ref(props.currentPage || 1)
const pageSize = ref(props.pageSize || 10)
const small = ref(false)
// const background = ref(false)
const disabled = ref(false)

const emit = __emit

const handleSizeChange = (val: number) => {
  console.log(`${val} items per page`)
  emit('update:pageSize',val)
  emit('pagination', { perPage: val })
}
const handleCurrentChange = (val: number) => {
  console.log(`current page: ${val}`)
  emit('update:currentPage',val)
  emit('pagination', { page: val })
}

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_pagination, {
      "current-page": currentPage.value,
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
      "page-size": pageSize.value,
      "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
      "page-sizes": [10, 20, 30, 40],
      small: small.value,
      disabled: disabled.value,
      background: props.background,
      layout: "->,total,prev, pager, next,sizes,jumper",
      total: props.total,
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange
    }, null, 8, ["current-page", "page-size", "small", "disabled", "background", "total"])
  ]))
}
}

})